module.exports = __webpack_public_path__ + "static/img/footwear01.960792b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anatomy/footwear01.png
// module id = 4uBL
// module chunks = 0